module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_10.jpg?v=affdec19";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_10.jpg
 ** module id = 67
 ** module chunks = 1 2
 **/